import { CosmosClient } from "@azure/cosmos";
import { authProvider } from './authProvider';

export class CartUtil {

  public async GetDiscount(_document: any) {
    let accountInfo = await authProvider.getAccountInfo();
    let email = accountInfo === null ? '' : accountInfo?.account.idToken.email;

    let API_URL = 'https://ultimatesprodevapilx01.azurewebsites.net/api';
    let API_ENDPOINT = '/ValidateDiscount?code=YhMJAgToh9Wg3IrlPSUwX26sBK3GUpPURuPe7YudfbXpCMdCVqUEoA==';
    
    let API = API_URL + API_ENDPOINT;
    let response = await fetch(API,
      {
        method: "post",
        headers: new Headers({
          "Authorization": "Bearer " + accountInfo?.jwtIdToken,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(_document)
      }
    );

    // if (response.ok) {
    //   let result = await response.json();
    //   return result;
    // } else {
    //   return { _document};
    // }
    if (response.ok) {
      let result = await response.json();
      if (result.isSuccess) {
          return result; // Newly created document
      } else {
          return { errors : result.errors };
      }
    } else {
        // Error return from Azure Fucntion
        let errorResponse = await response.json();
        return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
    }
  }

  
  public async SendPayment(_doc: any) {

    // let fd = new FormData();
    // fd.append('TransactionType'   , _doc['TransactionType']);   // SALE or AUTH
    // fd.append('PymtMethod'        , _doc['PymtMethod']);        // ANY
    // fd.append('ServiceID'         , _doc['ServiceID']);         // A00
    // fd.append('PaymentID'         , _doc['PaymentID']);         // ABCDEFGHI123123213
    // fd.append('OrderNumber'       , _doc['OrderNumber']);       // IJKLMN
    // fd.append('PaymentDesc'       , _doc['PaymentDesc']);       // Booking No: IJKLNMS ......
    // fd.append('MerchantName'      , _doc['MerchantName']);      // Merchant A
    // fd.append('MerchantReturnURL' , _doc['MerchantReturnURL']); // https://merchA.merchadomain.com/pymtresp.aspx
    // fd.append('MerchantCallbackURL', _doc['MerchantCallbackURL']); // https://merchA.merchadomain.com/pymtrespcallback.aspx
    // fd.append('Amount' , _doc['Amount']); // Exclude ",", with 2 decimal place
    // fd.append('CurrencyCode' , _doc['CurrencyCode']); //MYR
    // fd.append('CustIP' , _doc['']);
    // fd.append('CustName' , _doc['']);
    // fd.append('CustEmail' , _doc['']);
    // fd.append('CustPhone' , _doc['']);
    // fd.append('HashValue' , _doc['']);
    // fd.append('MerchantTermsURL' , _doc['']);
    // fd.append('LanguageCode' , _doc['']);
    // fd.append('PageTimeout' , _doc['']);



  }

}
